import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import i18n from "./i18n";
import { I18nextProvider } from "react-i18next";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { inicializarDemoSiCorresponde } from "./mockup";

// Si la sesion previa quedo en modo demo (flag en localStorage), reinstalamos
// el interceptor de fetch antes de montar React para que las cards/grilla
// se hidraten contra los datos mock en lugar de salir a la red.
inicializarDemoSiCorresponde();

const RouterMain = lazy(() => import("./router"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18n}>
      <Suspense fallback={<div style={{ height: 1 }} />}>
        <>
          <RouterMain />
          {/* ToastContainer al nivel global */}
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            pauseOnHover
            draggable
          />
        </>
      </Suspense>
    </I18nextProvider>
  </React.StrictMode>,
);
